import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import SettingsSidebar from "../../sidebar";
import { Alert, confirm } from "modules/theme";
import { CenterFlexRow, BackButton } from "../../styles";
import APIManager from "modules/common/apiManager";
import { Row, RowTitle, Box, BoxName, Divider } from "../../main/styles";
import { BarItems } from "modules/theme";
//import { DataWrapperClass } from '../styles';
import { Modal, MenuItem } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  SeachForm,
  DataWrapperClass,
  ButtonCommonTheme,
  Icon,
  SettingDropdownMenu,
} from "modules/theme";
import CSATAddEdit from "./CSATAddEdit";
import { leftSidebarType, modalType } from "../../../../../helpers/dotenv";
import { MdOutlineAdd } from "react-icons/md";
import { CustomDropdown } from "../../../../common/components";

class CSAT extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `CSAT`;
    this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
    };
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    // const ary = [];
    const list = this.state.SelectedList.map((data) => {
      // ary = data._id;
      this.state.ary.push(data._id);
      // this.setState({ ary: data._id });
    });
    this.mAPI.sendPostAPI(
      `setting/csat/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        this.getCSAT(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.contactId
        );
        Alert.success(`${this.moduleName} is deleted.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  search(e) {
    let teamList = this.state.listData;
    teamList.map((e) => (e.selected = false));
    this.setState({
      SelectedList: [],
      MasterChecked: false,
      SingleChecked: false,
      listData: teamList,
      currentPage: 1
    });
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value });
        this.getCSAT(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  componentDidMount() {
    this.getCSAT(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.contactId
    );
  }

  handleModalShowHide(data) {
    this.setState({ showHide: !this.state.showHide });
  }
  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getCSAT(
        this.state.currentPage,
        this.state.perPageCount,
        this.state.search
      );
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  getCSAT(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/csat?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });
        if (data && data.data) {
          that.setState({
            listData: data.data,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(`${error} : ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page });
    this.getCSAT(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getCSAT(1, perPage, this.state.search);
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  deleteCSAT(tCSAT) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/csat/${tCSAT._id}`,
      undefined,
      (data) => {
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tCSAT._id);
        that.setState({ listData: tD });
        that.getCSAT(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.contactId
        );
        Alert.success(`The ${tCSAT.name} is deleted.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  editCSAT(tCSAT) {
    return (
      /* <Tip text={`${'Edit'}`} key={`${'edit'}`}>
        <Button
          btnStyle="link"
          onClick={() => this.openModal(tCSAT)}
          style={{ verticalAlign: 'middle' }}
          icon="edit"
        ></Button>
      </Tip> */
      <ButtonCommonTheme
        type="edit"
        editOnClick={() => this.openModal(tCSAT)}
      />
    );
  }

  renderActions(tCSAT, index) {
    return (
      <ActionButtons>
        {this.editCSAT(tCSAT)}
        <CustomDropdown
          index={index}
          totalLength={this.state.listData.length || 0}
        >
          <MenuItem style={{ marginLeft: "0px" }}>
            <a
              onClick={(e) =>
                confirm().then((e) => {
                  this.deleteCSAT(tCSAT, e);
                })
              }
            >
              Delete
            </a>
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  renderActionBar() {
    /* const importTrigger = (
      <Button btnStyle="default" size="small">
        <img src='/images/plus.png' style={{ width: '12px' }} />
      </Button>
    ); */
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        {/* <SeachForm style={{marginRight:'10px'}}>
          <FormControl
            type="text"
            placeholder={'Search...'}
            onChange={e => this.search(e)}
            value={this.state.searchValue}
            autoFocus={false}
          />
        </SeachForm> */}
        {/* <FormControl
          type="text"
          placeholder={'Type to search'}
          onChange={e => this.search(e)}
          value={this.state.searchValue}
          autoFocus
        /> */}
        <ModalTrigger
          title="CSAT"
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <CSATAddEdit
            size="small"
            update={() => this.setState({ currentPage: 1 })}
            editData={this.state.editData}
            isEdit={false}
            closeModal={this.closeModal}
            modalType={this.state.modalType}
          />
        </ModalTrigger>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("CSAT"), link: "/settings/CSAT" },
    ];

    const mainContent = (
      <DataWrapperClass>
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th onClick={this.onClick}>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={(e) => this.onMasterCheck(e)}
                />
              </th>
              <th>{__("Name")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody id="CSAT">
            {this.state.listData.map((tCSAT, index) => (
              <tr key={tCSAT._id}>
                <td onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={tCSAT.selected}
                    onChange={(e) => this.onItemCheck(e, tCSAT)}
                  />
                </td>
                <td className="text-primary">{tCSAT.name}</td>
                <td>{this.renderActions(tCSAT, index)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    const actionBarRight = (
      <div>
        <BarItems>
          <Button
            btnStyle="default"
            onClick={() => this.handleModalShowHide()}
            icon="checked-1"
          >
            Add
          </Button>
        </BarItems>
      </div>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{`CSAT`}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search..."}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span className="material-symbols-outlined">search</span>
                    </SeachForm>
                    {/* <ControlLabel>{`CSAT (${this.state.total || 0})`}</ControlLabel> */}
                    {this.state.SelectedList.length > 0 ? (
                      /* <Tip text={`${'Delete'}`} key={`${'Delete'}`}>
                        <Button
                          btnStyle="danger"
                          size="small"
                          onClick={e =>
                            confirm().then(e => {
                              this.deleteAllData(e);
                            })
                          }
                          style={{
                            verticalAlign: 'middle',
                            marginLeft: '10px'
                          }}
                        // icon={'user-minus'}
                        >
                          <FiTrash2
                            style={{ fontSize: '14px', marginBottom: '-3px' }}
                          />
                        </Button>
                      </Tip> */
                      <ButtonCommonTheme
                        type="checkboxDelete"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    ) : (
                      ""
                    )}
                  </div>
                }
                // right={actionBarRight}
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText="Upload list of CSAT."
                  emptyImage="/images/CSAT-empty.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

CSAT.contextTypes = {
  __: PropTypes.func,
};

export default CSAT;



// WEBPACK FOOTER //
// src/modules/screens/settings/CSAT/components/CSAT.js